<canvas
	id="{{ getMapCanvasId() }}"
	style="width: 100%; height: calc(100% - 85px); min-height: 250px;"
	(window:resize)="onWindowResize()"
	>
</canvas>
